export function getUserSaveError(error) {
  const response = error?.response?.data;
  const detail = response?.detail ?? response?.message ?? response?.error;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map(item => typeof item === 'string' ? item : item?.msg || item?.message).filter(Boolean);
    if (messages.length) return messages.join(' ');
  }
  if (detail && typeof detail === 'object') {
    if (typeof detail.message === 'string') return detail.message;
    if (typeof detail.msg === 'string') return detail.msg;
  }
  return error?.message || 'Unable to save the user. Please try again.';
}
